import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getTeamMembers } from "../../../api/business";

export const fetchTeamMembers = createAsyncThunk(
  "fetchTeamMembers",
  async () => {
    const response = await getTeamMembers();
    return response;
  }
);
const teamSlice = createSlice({
  name: "team",
  initialState: {},
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTeamMembers.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchTeamMembers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.response = action.payload;
      })
      .addCase(fetchTeamMembers.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});
export { teamSlice };
